import React, { useState, memo, useEffect } from "react";
import {
  Grid,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  IconButton,
  Stack,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import configServ from "../../services/config";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
function JobMasterCard({
  jobCategoryList = [],
  editData = {},
  setEditData,
  isCreate,
  setIsCreate,
  isEdit,
  setIsChanged,
  setIsEdit,
}) {
  const initialState = {
    job_code: "",
    job_name: "",
    job_category_id: "",
    default_duration_min: "",
    job_type: "",
    is_active: true,
  };

  const { company_id, is_super, is_admin, permissions,user_id } = useSelector(
      (state) => state.GlobalVariables,
    );
  const [form, setForm] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // remove error on typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  useEffect(() => {
  if (editData) {
    setForm({
      job_code: editData.job_code || "",
      job_name: editData.job_name || "",
      job_category_id: editData.job_category_id || "",
      default_duration_min: editData.default_duration_min || "",
      job_type: editData.job_type || "",
      is_active: editData.is_active ?? true,
      id: editData.id, // for update
    });
  }
}, [editData]);

  const handleReset = () => {
  setForm({
    job_code: "",
    job_name: "",
    job_category_id: "",
    default_duration_min: "",
    job_type: "",
    is_active: true,
  });

  setErrors({});
  setEditData({})
  setIsEdit(false)
};

  const validate = () => {
    let err = {};

    if (!form.job_code) err.job_code = "Job Code required";
    if (!form.job_name) err.job_name = "Job Name required";
    if (!form.job_category_id) err.job_category_id = "Category required";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

 const handleSubmit = async () => {
  if (!validate()) return;
setLoading(true)
  try {
    const payload = {
      ...form,
      company_id: company_id,
      created_by:user_id
    };

    let res;

    if (isEdit) {
      // 👉 UPDATE API
      res = await configServ.updateJobMaster(form.id, payload);
    } else {
      // 👉 CREATE API
      res = await configServ.createJobMaster(payload);
    }

    if (res?.status  || res?.success) {
      handleReset();
      setIsCreate(false)
      setIsChanged((prev) => !prev)
      toast.success(isEdit ? "Updated Successfully" : "Created Successfully");
    }
  } catch (e) {
    console.log(e);
  } finally {
    setLoading(false);
  }
};

  return (
    <Box
      sx={{
        backgroundColor: "#e3f3fc",
        p: 2,
        borderRadius: 2,
        m: 1,
      }}
    >
      <Grid container spacing={2}>
        {/* Job Code */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Job Code"
            fullWidth
            size="small"
            name="job_code"
            value={form.job_code}
            onChange={handleChange}
            error={!!errors.job_code}
            helperText={errors.job_code}
            sx={{ backgroundColor: "white" }}
          />
        </Grid>

        {/* Job Name */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Job Name"
            fullWidth
            size="small"
            name="job_name"
            value={form.job_name}
            onChange={handleChange}
            error={!!errors.job_name}
            helperText={errors.job_name}
            sx={{ backgroundColor: "white" }}
          />
        </Grid>

        {/* Job Category */}
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth size="small" error={!!errors.job_category_id}>
            <InputLabel>Category</InputLabel>
            <Select
              name="job_category_id"
              value={form.job_category_id}
              label="Category"
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
            >
              {jobCategoryList.map((cat) => (
                <MenuItem key={cat.id} value={cat.id}>
                  {cat.job_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Duration */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Duration (Min)"
            type="number"
            fullWidth
            size="small"
            name="default_duration_min"
            value={form.default_duration_min}
            onChange={handleChange}
            sx={{ backgroundColor: "white" }}
          />
        </Grid>

        {/* Job Type */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Job Type"
            fullWidth
            size="small"
            name="job_type"
            value={form.job_type}
            onChange={handleChange}
            sx={{ backgroundColor: "white" }}
          />
        </Grid>

        {/* Active */}
        <Grid item xs={12} sm={6} md={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={form.is_active}
                onChange={handleChange}
                name="is_active"
              />
            }
            label="Active"
          />
        </Grid>

        {/* Submit Button */}
        <Grid item xs={12} md={12} textAlign="right">
          <Stack direction="row" justifyContent="flex-end" spacing={1}>
            {/* Reset button (only when NOT edit) */}
            <IconButton
                onClick={handleReset}
                sx={{
                  backgroundColor: "secondary.main",
                  color: "white",
                  "&:hover": { backgroundColor: "secondary.dark" },
                }}
                title="Reset"
              >
                <RotateLeftIcon />
              </IconButton>

            {/* Save / Update button */}
            <IconButton
              onClick={handleSubmit}
              disabled={loading}
              sx={{
                backgroundColor: isEdit ? "success.main" : "primary.main",
                color: "white",
                "&:hover": {
                  backgroundColor: isEdit ? "success.dark" : "primary.dark",
                },
              }}
              title={isEdit ? "Update" : "Save"}
            >
              <SaveIcon />
            </IconButton>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(JobMasterCard);
